import { tv } from "@ui/lib/tv";
import type { ReactNode } from "react";

const cardTag = tv({
  base: "flex h-7 items-center gap-1 rounded-full border-[1.5px] border-white bg-white/80 text-sm font-semibold leading-5 text-neutral-600 shadow-chip backdrop-blur-sm",
  variants: {
    shape: {
      pill: "",
      /** Fixed 28px circle — e.g. a numeric rank badge. */
      circle: "w-7 justify-center",
    },
    withIcon: {
      true: "",
      false: "",
    },
  },
  compoundVariants: [
    { shape: "pill", withIcon: false, className: "px-2.5" },
    // Icons are round: tuck the left padding in so the icon sits optically balanced.
    { shape: "pill", withIcon: true, className: "pl-[5px] pr-[7px]" },
  ],
  defaultVariants: { shape: "pill" },
});

export interface CardTagProps {
  children: ReactNode;
  className?: string;
  /** Leading icon, rendered before the label with tucked-in padding. */
  icon?: ReactNode;
  shape?: "pill" | "circle";
}

export function CardTag({ children, className, icon, shape }: CardTagProps) {
  return (
    <div className={cardTag({ shape, withIcon: icon != null, className })}>
      {icon}
      {children}
    </div>
  );
}
